import { ContractPeriodDealsResponseType } from "../../../../requests_cm/gecoContractsService/types";

export const filterDealsByContractPeriod = <
	T extends Pick<ContractPeriodDealsResponseType, "start_date" | "end_date">
>(
	deals: T[] | undefined,
	contractPeriodStartDate: string,
	contractPeriodEndDate: string
): T[] | undefined => {
	if (!deals) {
		return deals;
	}

	const startDate = new Date(contractPeriodStartDate).getTime();
	const endDate = new Date(contractPeriodEndDate).getTime();

	return deals.filter((deal) => {
		const dealStartDate = new Date(deal.start_date).getTime();
		const dealEndDate = new Date(deal.end_date).getTime();

		return dealStartDate >= startDate && dealEndDate <= endDate;
	});
};